"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrowUpEvent = exports.isArrowDownEvent = exports.isEscapeEvent = exports.isSpaceEvent = exports.isEnterEvent = void 0;
const EventKey_1 = __importDefault(require("../hooks/eventKeyHandlers/EventKey"));
const isArrowUpEvent = (ev) => ev.key === EventKey_1.default.ArrowUp;
exports.isArrowUpEvent = isArrowUpEvent;
const isArrowDownEvent = (ev) => ev.key === EventKey_1.default.ArrowDown;
exports.isArrowDownEvent = isArrowDownEvent;
const isEnterEvent = (ev) => ev.key === EventKey_1.default.Enter;
exports.isEnterEvent = isEnterEvent;
const isSpaceEvent = (ev) => ev.code === EventKey_1.default.Space || ev.key === EventKey_1.default.Space;
exports.isSpaceEvent = isSpaceEvent;
const isEscapeEvent = (ev) => ev.key === EventKey_1.default.Escape;
exports.isEscapeEvent = isEscapeEvent;
